import { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import PublicNav from '../../../components/layout/PublicNav';

/**
 * Docs Component
 * 📚 Coming soon page for documentation
 */
const Docs = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    
    setIsSubmitting(true);
    
    // Simulating API call for email subscription
    setTimeout(() => {
      toast.success('Thanks for subscribing! We\'ll notify you when our docs are ready.');
      setEmail('');
      setIsSubmitting(false);
    }, 800);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#6C5DD3] to-[#8247E5]">
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto bg-white bg-opacity-95 backdrop-blur-sm rounded-3xl shadow-xl overflow-hidden">
          <div className="p-8 md:p-12">
            <PublicNav />

            <div className="text-center mb-12">
              <h1 className="text-3xl font-bold text-[#6C5DD3] mb-4">Documentation Coming Soon</h1>
              <div className="h-1 w-24 bg-gradient-to-r from-[#6C5DD3] to-[#8247E5] mx-auto rounded-full mb-6"></div>
              <p className="text-gray-700 text-lg max-w-2xl mx-auto">
                We're working hard on comprehensive documentation to help you get the most out of MnyMny.
                Subscribe below to be notified when our documentation is ready.
              </p>
            </div>

            <div className="flex flex-col md:flex-row gap-8 mb-12">
              <div className="bg-gradient-to-br from-purple-50 to-indigo-50 p-6 rounded-xl flex-1">
                <div className="text-[#6C5DD3] mb-3">
                  <svg className="w-10 h-10" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 4.804A7.968 7.968 0 005.5 4c-1.255 0-2.443.29-3.5.804v10A7.969 7.969 0 015.5 14c1.669 0 3.218.51 4.5 1.385A7.962 7.962 0 0114.5 14c1.255 0 2.443.29 3.5.804v-10A7.968 7.968 0 0014.5 4c-1.255 0-2.443.29-3.5.804V12a1 1 0 11-2 0V4.804z"></path>
                  </svg>
                </div>
                <h3 className="text-xl font-semibold text-gray-800 mb-2">User Guides</h3>
                <p className="text-gray-700">
                  Step-by-step instructions for setting up your account, connecting with your partner, 
                  and making the most of all our features.
                </p>
              </div>

              <div className="bg-gradient-to-br from-purple-50 to-indigo-50 p-6 rounded-xl flex-1">
                <div className="text-[#6C5DD3] mb-3">
                  <svg className="w-10 h-10" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" d="M12.316 3.051a1 1 0 01.633 1.265l-4 12a1 1 0 11-1.898-.632l4-12a1 1 0 011.265-.633zM5.707 6.293a1 1 0 010 1.414L3.414 10l2.293 2.293a1 1 0 11-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0zm8.586 0a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 11-1.414-1.414L16.586 10l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd"></path>
                  </svg>
                </div>
                <h3 className="text-xl font-semibold text-gray-800 mb-2">API Reference</h3>
                <p className="text-gray-700">
                  Technical documentation for developers who want to integrate with MnyMny 
                  or build extensions for our platform.
                </p>
              </div>

              <div className="bg-gradient-to-br from-purple-50 to-indigo-50 p-6 rounded-xl flex-1">
                <div className="text-[#6C5DD3] mb-3">
                  <svg className="w-10 h-10" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.394 2.08a1 1 0 00-.788 0l-7 3a1 1 0 000 1.84L5.25 8.051a.999.999 0 01.356-.257l4-1.714a1 1 0 11.788 1.838L7.667 9.088l1.94.831a1 1 0 00.787 0l7-3a1 1 0 000-1.838l-7-3zM3.31 9.397L5 10.12v4.102a8.969 8.969 0 00-1.05-.174 1 1 0 01-.89-.89 11.115 11.115 0 01.25-3.762zM9.3 16.573A9.026 9.026 0 007 14.935v-3.957l1.818.78a3 3 0 002.364 0l5.508-2.361a11.026 11.026 0 01.25 3.762 1 1 0 01-.89.89 8.968 8.968 0 00-5.35 2.524 1 1 0 01-1.4 0zM6 18a1 1 0 001-1v-2.065a8.935 8.935 0 00-2-.712V17a1 1 0 001 1z"></path>
                  </svg>
                </div>
                <h3 className="text-xl font-semibold text-gray-800 mb-2">Financial Guides</h3>
                <p className="text-gray-700">
                  Educational resources on budgeting, saving, and managing finances as a couple, 
                  with practical tips you can apply today.
                </p>
              </div>
            </div>

            <div className="bg-gradient-to-br from-purple-100 to-indigo-100 p-8 rounded-xl">
              <h3 className="text-xl font-semibold text-gray-800 mb-4 text-center">
                Get Notified When Our Documentation Launches
              </h3>
              <form onSubmit={handleSubmit} className="max-w-lg mx-auto">
                <div className="flex flex-col sm:flex-row gap-3">
                  <input 
                    type="email" 
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Your email address" 
                    className="flex-1 px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#6C5DD3] focus:border-transparent text-gray-900"
                    required
                  />
                  <button 
                    type="submit"
                    disabled={isSubmitting} 
                    className="whitespace-nowrap px-6 py-3 bg-gradient-to-r from-[#6C5DD3] to-[#8247E5] text-white font-medium rounded-xl hover:opacity-90 transition duration-200 disabled:opacity-70"
                  >
                    {isSubmitting ? 'Subscribing...' : 'Notify Me'}
                  </button>
                </div>
              </form>
            </div>

            <div className="mt-12 text-center text-gray-600">
              <p>
                Can't wait? Check out our{' '}
                <Link to="/about" className="text-[#6C5DD3] hover:underline">
                  about page
                </Link>
                {' '}or{' '}
                <Link to="/login" className="text-[#6C5DD3] hover:underline">
                  sign in
                </Link>
                {' '}to explore MnyMny.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Docs; 